import { WebPlugin } from '@capacitor/core';
export class ApplicationContextWeb extends WebPlugin {
    async updateApplicationContext(applicationContext) {
        applicationContext; // Silently do nothing
        return undefined;
    }
}
//# sourceMappingURL=web.js.map